import LogoLink from './logo-link-view';

export default LogoLink;
